import ReactDOM from 'react-dom/client';

import { AppVersionV3 } from 'app/v3';

import './firebase';
import './global';

const rootElement = document.getElementById('root')!;
const root = ReactDOM.createRoot(rootElement);

const AppLoader = () => {
  const currentPath = window.location.pathname;

  switch (true) {
    case currentPath.startsWith('/v3'):
      return <AppVersionV3 />;
    default:
      return <AppVersionV3 />;
  }
};

root.render(<AppLoader />);
